<template>
  <div class="c-gallery">
    <file-upload
      name="field1"
      @uploaded="onFileUploaded"
      resource="content1"
      :bypassDuplicate="true"
      :fileTypes="['png','jpg']"
      multiple
      v-show="!localFiles || localFiles.length == 0 || forceUpload"
      v-if="displayUpload"
    ></file-upload>
    <base-button
      type="button"
      v-if="localFiles && localFiles.length > 0"
      @click="onAddMore"
      :isPrimary="true"
    >Add more</base-button>
    <base-button
      type="button"
      v-if="localFiles && localFiles.length > 0"
      @click="onReset"
    >Remove All</base-button>
    <draggable
      :list="localFiles"
      @start="onPageElementDragStart"
      @end="onPageElementDragEnd"
      :options="{group:'files'}"
      class="c-gallery__list"
    >
      <div v-for="file in localFiles" :key="file" class="c-gallery__list-item">
        <media-image :fileId="file"/>
        <button
          type="button"
          @click="removeFile(file)"
          class="c-gallery__list-item__control danger"
        >x</button>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import FileUpload from "@/components/FileUpload";

export default {
  name: "FormGallery",

  components: {
    FileUpload,
    draggable
  },
  props: {
    files: {
      type: String,
      default: "[]"
    }
  },

  data() {
    return {
      uploadComplete: false,
      drag: false,
      pageElementDrag: false,
      localFiles: [],
      displayUpload: true,
      forceUpload: false
    };
  },
  methods: {
    removeFile(fileid) {
      this.localFiles = this.localFiles.filter(file => file != fileid);
      this.$emit("galleryUpdated", this.localFiles);
    },
    onFileUploaded(val) {
      this.localFiles.push(val.id);
      this.forceUpload = false;
      this.$emit("uploaded", this.localFiles);
    },
    onAddMore() {
      this.displayUpload = false;

      setTimeout(() => {
        this.displayUpload = true;
        this.forceUpload = true;
      }, 100);
    },
    onReset() {
      this.localFiles = [];
      this.displayUpload = false;
      setTimeout(() => {
        this.displayUpload = true;
      }, 100);
    },
    markComplete() {
      this.uploadComplete = true;
    },
    onPageElementDragStart(event) {
      this.drag = true;
      this.pageElementDrag = true;
    },

    //when we finish dragging, emit the new value
    onPageElementDragEnd(event) {
      this.$emit("galleryUpdated", this.localFiles);
      this.drag = false;
      this.pageElementDrag = false;
    }
  },

  created() {
    if (this.files && this.files != 'Click to Edit') { // TODO: Really need a better way of doing this for group
      this.localFiles = JSON.parse(this.files);
    }
  }
};
</script>

<style lang="scss">
.c-gallery {
  max-height: 500px;
  overflow-x: scroll;
  &__list {
    list-style-type: none;
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    &-item {
      align-items: center;
      list-style-type: none;
      display: inline-flex;
      width: 33%;
      padding: 5px 5px 5px 0;
      position: relative;
      cursor: move;
      // height: 200px;

      .c-media-image {
        margin: 0;
        height: 170px;
        width: 100%;

        img {

          @supports (object-fit: cover) {
            min-height: 75px;
            width: 100%;
            min-width: 75px;
            height: 100%;
            object-fit: cover;
            height: 170px !important;
          }
        }
      }

      &__control {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 100%;
        background-color: $colour-nhs-emergency-red;
        color: $colour-nhs-core-white;
        border: 2px solid $colour-nhs-core-white;
        cursor: pointer;
        transition: all ease-in-out 0.2s;

        &:hover {
          background: darken($colour-nhs-emergency-red, 10%);
        }
      }

      &:hover & {
        &__control {
          display: block;
        }
      }
    }
  }
}
</style>
